import { HELPERS } from '@/utils';
import http, { getAuthConfig } from './http';

const BASE_URL = '/courses';
const TENANT_ID = process.env.REACT_APP_TENANT_TITLE;

const getCourseListData = (queries, callback) => {
  http
    .get(`/tenant/${TENANT_ID}${BASE_URL}${queries}`, getAuthConfig())
    .then((res) => callback({ payload: res.data.payload, error: null, success: true }))
    .catch((error) => callback({ payload: null, error: error.response, success: false }));
};

const getCourseDetailData = (slug, callback) => {
  http
    .get(`/tenant/${TENANT_ID}${BASE_URL}/${slug}`, getAuthConfig())
    .then((res) => callback({ payload: res.data.payload, error: null, success: true }))
    .catch((error) => callback({ payload: null, error: error.response, success: false }));
};

const sendCourseProgress = (slug, topicUUID, action, timestamp, callback) => {
  const data = { topic_uuid: topicUUID, action, timestamp };

  http
    .post(`${BASE_URL}/${slug}/progress`, data, getAuthConfig())
    .then((res) => callback({ payload: res.data.payload, error: null, success: true }))
    .catch((error) => callback({ payload: null, error: error.response, success: false }));
};

const getCourseReport = (slug, callback) => {
  http
    .get(`/tenant/${TENANT_ID}${BASE_URL}/${slug}/report`, getAuthConfig())
    .then((res) => callback({ payload: res.data.payload, error: null, success: true }))
    .catch((error) => callback({ payload: null, error: error.response, success: false }));
};

const getCourseComment = (slug, callback) => {
  http
    .get(`/tenant/${TENANT_ID}${BASE_URL}/${slug}/comments`, getAuthConfig())
    .then((res) => callback({ payload: res.data.payload, error: null, success: true }))
    .catch((error) => callback({ payload: null, error: error.response, success: false }));
};

const sendCourseComment = (slug, comment, commentUuid, callback) => {
  const data = { course_slug: slug, comment };

  if (commentUuid) Object.assign(data, { comment_uuid: commentUuid });

  http
    .post(`/comments`, data, getAuthConfig())
    .then((res) => callback({ payload: res.data.payload, error: null, success: true }))
    .catch((error) => callback({ payload: null, error: error.response, success: false }));
};

const sendCourseCommentReport = (uuid, reason, callback) => {
  const data = { reason };

  http
    .post(`/comments/${uuid}/reports`, data, getAuthConfig())
    .then((res) => callback({ payload: res.data.payload, error: null, success: true }))
    .catch((error) => callback({ payload: null, error: error.response, success: false }));
};

const setCourseCommentLike = (commentUuid, likeUnlike, callback) => {
  const data = { like: likeUnlike };

  http
    .post(`/comments/${commentUuid}/likes`, data, getAuthConfig())
    .then((res) => callback({ payload: res.data.payload, error: null, success: true }))
    .catch((error) => callback({ payload: null, error: error.response, success: false }));
};


const getCatalogsInfiniteWithQuery = async ({ queryKey, pageParam }) => {
  const filters = queryKey[1] ? { ...queryKey[1], page: pageParam } : { page: pageParam };
  const apiCallFilters = { ...filters };

  if (filters.tenant_only === 'all') {
    delete apiCallFilters.tenant_only;
  } 

  const queries = HELPERS.objectToQueryString(apiCallFilters);

  return http
    .get(`/tenant/${TENANT_ID}${BASE_URL}${queries}`, getAuthConfig())
    .then((res) => {
      const data = res.data.payload;
      return data;
    })
    .catch((error) => {
      HELPERS.showNotificationServiceError('Terjadi Kesalahan');
      throw error;
    });
};

const generateQueryKeys = ({ query, tenantOnly, priceMin, priceMax, categoryId, perPage, itemType, authDependentKey }) => {
  return [
    'courses',
    {
      query,
      tenant_only: tenantOnly,
      price_min: priceMin,
      price_max: priceMax,
      category_id: categoryId,
      per_page: perPage,
      item_type: itemType,
      auth_status: authDependentKey,
    },
  ];
};

export const SERVICE_COURSE = {
  getCourseListData,
  getCourseDetailData,
  sendCourseProgress,
  getCourseReport,
  getCourseComment,
  sendCourseComment,
  sendCourseCommentReport,
  setCourseCommentLike,
  getCatalogsInfiniteWithQuery,
  generateQueryKeys
};
